import * as React from 'react';
import Box from '@material-ui/core/Box';

import Typography from '@material-ui/core/Typography';
import helper from 'src/utils/helpers';
import { Paper } from '@material-ui/core';


const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);

export default function BasicCard({data}) {
  return (
    <Paper sx={{ minWidth: 275, p: 2 }}>
         <Typography variant="h5" component="div" className="text-info">
           Details
           </Typography>
        <Box sx={{ display: 'flex'}}>
           
        <Typography variant="h5" component="div" className="flex-grow-1">
        {bull} Amount 
        </Typography>
        <Typography variant="h5" component="div">
        {helper.toCurrency(data.maxAmount)}
        </Typography>
        </Box>
        <Box sx={{ display: 'flex'}}>
           
           <Typography variant="h5" component="div" className="flex-grow-1">
           {bull} Weekly Rate
           </Typography>
           <Typography variant="h5" component="div">
           {Number(data.weeklyRate * 100).toFixed(1)} %
           </Typography>
           </Box>
           <Box sx={{ display: 'flex'}}>
           
           <Typography variant="h5" component="div" className="flex-grow-1">
           {bull} Semi-monthly Rate
           </Typography>
           <Typography variant="h5" component="div">
           {Number(data.smRate * 100).toFixed(1)} %
           </Typography>
           </Box>
        
        <Box className="center-element"> 
        <Typography variant="h5" component="div" className="text-left mt-2 flex-grow-1">
       {bull}  Terms
        </Typography>    
        </Box>
        <Box sx={{ display: 'flex'}}>
        <Typography variant="h5" component="div" className="flex-grow-1 ml-3">
       {bull} ({data.weeklyTerm}) Weekly / {data.weeklyTerm * 7} Days 
           </Typography>
        
           </Box>
           <Box sx={{ display: 'flex'}}>
        <Typography variant="h5" component="div" className="flex-grow-1 ml-3">
        {bull} ({data.smTerm}) Semi-monthly / {data.smTerm * 15} Days 
           </Typography>
         
           </Box>
           <br/>
           <Typography variant="h5" component="div" className="text-danger">
           {bull} Requirements
           </Typography>
           <Box sx={{ display: 'flex'}}>
        <Typography variant="h5" component="div" className="flex-grow-1 ml-3">
           {bull} Fix Deposit 
           </Typography>
           <Typography variant="h5" component="div">
           {helper.toCurrency(500)}
        </Typography>
           </Box>
    </Paper>
  );
}
